import { createStore } from 'effector'

import { type PageUrl, setPrevPage, setNextPage, reset } from '../../index'

const $prevPage = createStore<PageUrl>(null)
  .on(setPrevPage, (_, prevPage) => prevPage)
  .reset(reset)

const $nextPage = createStore<PageUrl>(null)
  .on(setNextPage, (_, nextPage) => nextPage)
  .reset(reset)

const $shouldRedirectToTransferCentre = createStore<boolean>(false).reset(reset)

export { $prevPage, $nextPage, $shouldRedirectToTransferCentre }
